'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.milliseconds;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/milliseconds.js
// module id = 177
// module chunks = 0